import { pdf } from "@react-pdf/renderer";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../Firebase Functions/firebase";
import axios from "axios";
import VendorRequestPDF from "../PDF Functions/VendorRequestPDF";

const quickbaseApi = axios.create({
  baseURL: "https://api.quickbase.com/v1",
  headers: {
    "QB-Realm-Hostname": process.env.REACT_APP_QB_REALM_HOSTNAME,
    Authorization: `QB-USER-TOKEN ${process.env.REACT_APP_QB_API_KEY}`,
    "Content-Type": "application/json",
  },
});

const QB_FIELDS = {
  recordId: 3,
  incidentId: 12,
  vendorPdf: 14,
};

const findQuickBaseRecordIdByIncidentId = async (incidentId) => {
  const queryPayload = {
    from: "buz6rhchu", // Make sure this is your QuickBase table ID
    select: [QB_FIELDS.recordId, QB_FIELDS.incidentId],
    where: `{${QB_FIELDS.incidentId}.EX.'${incidentId}'}`,
  };

  const response = await quickbaseApi.post("/records/query", queryPayload);
  const records = response.data?.data || [];
  return records.length > 0 ? records[0][QB_FIELDS.recordId].value : null;
};

const UploadVendorRequestToQuickBase = async (incidentId) => {
  try {
    console.log("🚀 Starting QuickBase upload for vendorRequestForm:", incidentId);

    const docRef = doc(db, "vendorRequestForm", incidentId); // 🔄 updated collection name
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      throw new Error("Vendor request form not found in Firebase.");
    }

    const formData = docSnap.data();
    console.log("📄 vendorRequestForm formData:", formData);

    const pdfBlob = await pdf(<VendorRequestPDF formData={formData} />).toBlob();
    const arrayBuffer = await pdfBlob.arrayBuffer();
    const pdfBase64 = btoa(
      new Uint8Array(arrayBuffer).reduce((acc, byte) => acc + String.fromCharCode(byte), "")
    );

    const existingRecordId = await findQuickBaseRecordIdByIncidentId(incidentId);
    console.log("🔎 Found existing QuickBase record ID:", existingRecordId);

    const record = {
      [QB_FIELDS.incidentId]: { value: incidentId },
      [QB_FIELDS.vendorPdf]: {
        value: {
          fileName: `CreditCardRequest_${incidentId}.pdf`,
          data: pdfBase64,
        },
      },
    };

    if (existingRecordId) {
      record[QB_FIELDS.recordId] = { value: existingRecordId };
    }

    const response = await quickbaseApi.post("/records", {
      to: "buz6rhchu",
      data: [record],
    });

    console.log("✅ VendorRequest PDF uploaded to QuickBase:", response.data);

    const newRecordId =
      response.data?.metadata?.createdRecordIds?.[0] ||
      response.data?.metadata?.updatedRecordIds?.[0] ||
      null;

    if (!existingRecordId && newRecordId) {
      await updateDoc(doc(db, "incidentReports", incidentId), {
        quickbaseId: newRecordId,
      });
    }

    return {
      data: response.data,
      recordId: newRecordId,
    };
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Unknown error";
    console.error("❌ Error uploading vendorRequestForm to QuickBase:", message);
    throw new Error(message);
  }
};

export default UploadVendorRequestToQuickBase;
